module.exports = __webpack_public_path__ + "static/img/gcd.9ca40cd.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/shops/gcd.png
// module id = 297+
// module chunks = 1